import React, { useContext } from "react";
import {
  SpacingBox,
  CloudDownloadIcon,
  Paragraph,
  ClickableFlexBox,
  SpinnerIcon,
} from "../../../Components";
import AppContext from "../../../AppContext";
import { translate } from "./../translate";

import { getUser } from "../../../selectors";

import useSyncOrdersSalesforce from "./useSyncOrdersSalesforce";

export const SyncOrdersSalesforce = () => {
  const context = useContext(AppContext);
  const user = getUser(context);
  const sharedUserId = "005aV000004JFU5QAO";
  const { loading, handleOnClick } = useSyncOrdersSalesforce();

  if (user.id === sharedUserId) {
    return <></>;
  }

  return (
    <ClickableFlexBox
      onClick={handleOnClick}
      marginLeft="xl"
      alignItems="center"
    >
      <SpacingBox marginRight="md">
        {loading ? <SpinnerIcon /> : <CloudDownloadIcon size="sm" />}
      </SpacingBox>
      <Paragraph>{translate("syncOrdersButton")}</Paragraph>
    </ClickableFlexBox>
  );
};
